// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2vy-i","paramInput":"JobSimulator_paramInput__3ZWfr","input":"JobSimulator_input__1mtjP"};